import { useState, useEffect } from 'react';
import { CompositeFieldType } from '#types/System.types';
import { fetchAllCompositeFieldTypes } from './compositeFieldTypeCache';

/**
 * Returns all CompositeFieldTypes from a static cache.
 * Fetches once on first access; stale until app reload.
 */
export const useCompositeFieldTypes = (): CompositeFieldType[] => {
    const [types, setTypes] = useState<CompositeFieldType[]>([]);

    useEffect(() => {
        let cancelled = false;
        fetchAllCompositeFieldTypes().then(result => {
            if (!cancelled) setTypes(result);
        });
        return () => { cancelled = true; };
    }, []);

    return types;
};
